import { EditorEventType, EditorSetupEventType, } from '../common/editor-events';
import { SDKEventType } from '../common/events';
import { ViewerSetupEventType, ViewerEventType, } from '../common/viewer-events';
const LOGGER_PREFIX = 'viewer-SDK: ';
const noop = () => { };
export class ViewerSdk {
    constructor({ shouldLog, origin, onReady = noop, }) {
        this.messageHandlers = {};
        this.onReady = noop;
        if (origin === false) {
            console.warn(LOGGER_PREFIX, 'dengariously set init sdk in non-secure mode');
        }
        this.origin = origin || '*';
        this.onReady = onReady;
        this.logger = (...args) => {
            if (shouldLog) {
                console.log(LOGGER_PREFIX, ...args);
            }
        };
        this.logger('new viewer instance');
        this.setupWindowListener();
    }
    setupWindowListener() {
        window.addEventListener('message', (e) => {
            if (e.data.scope !== SDKEventType.setup) {
                return;
            }
            switch (e.data.type) {
                case EditorSetupEventType.sendMessagePort:
                    this.logger('got message port');
                    this.viewerPort = e.ports[0];
                    this.setupPortListener();
                    break;
                default:
            }
        });
        this.sendPortRequest();
    }
    sendPortRequest() {
        const message = {
            scope: SDKEventType.setup,
            type: ViewerSetupEventType.readyForPort,
        };
        window.parent.postMessage(message, this.origin);
        this.logger('sent port request');
    }
    setupPortListener() {
        if (!this.viewerPort) {
            throw new Error('tried to listen on port before it was received');
        }
        this.viewerPort.addEventListener('message', (e) => {
            this.logger('got a message: ', e.data?.type, e.data);
            const fn = this.messageHandlers[e.data.type] ||
                (() => Promise.reject(new Error(`Handler was not defined on viewer for type: ${e.data.type}`)));
            fn(e.data.payload)
                .then((res) => {
                return this.resolveRequest(e.data.id, res);
            })
                .catch((err) => this.rejectRequest(e.data.id, err));
            switch (e.data.type) {
                case EditorEventType.updatePageStructure:
                    this.logger('update structure');
                    break;
                case EditorEventType.updateBranding:
                    this.logger('update branding');
                    break;
                case EditorEventType.navigateToPage:
                    this.logger('navigate');
                    break;
                case EditorEventType.updateComponent:
                    this.logger('update component');
                    break;
                case EditorEventType.updateCustomFields:
                    this.logger('update custom fields');
                    break;
                case EditorEventType.getCompiledTemplate:
                    this.logger('get compiled templates');
                    break;
                default:
                    this.logger('no handler for this message', e.data);
                    throw new Error('unsupported event type');
            }
        });
        this.viewerPort.start();
        this.logger('registered to editor events');
        this.notifyReady();
        this.onReady();
    }
    resolveRequest(id, res) {
        this.sendMessage({
            scope: SDKEventType.sdk,
            type: ViewerEventType.success,
            id,
            payload: res,
        });
    }
    rejectRequest(id, err) {
        this.sendMessage({
            scope: SDKEventType.sdk,
            type: ViewerEventType.error,
            id,
            payload: err,
        });
    }
    notifyReady() {
        this.sendMessage({ scope: SDKEventType.sdk, type: ViewerEventType.ready });
    }
    onPageUpdate(handler) {
        this.messageHandlers[EditorEventType.updatePageStructure] = handler;
    }
    onBrandingUpdate(handler) {
        this.messageHandlers[EditorEventType.updateBranding] = handler;
    }
    onNavigate(handler) {
        this.messageHandlers[EditorEventType.navigateToPage] = handler;
    }
    onComponentUpdate(handler) {
        this.messageHandlers[EditorEventType.updateComponent] = handler;
    }
    onUpdateCustomFields(handler) {
        this.messageHandlers[EditorEventType.updateCustomFields] = handler;
    }
    onGetCompiledTemplate(handler) {
        this.messageHandlers[EditorEventType.getCompiledTemplate] = handler;
    }
    sendMessage(event) {
        if (!this.viewerPort) {
            throw new Error('tried to send a message before port was received');
        }
        this.viewerPort.postMessage(event);
        this.logger('sent message', event);
    }
}
//# sourceMappingURL=viewer-sdk.js.map